import { Tag } from '@doda/common/src/components/Head/metaTag';
import {
  OGP_TYPE,
  OGP_IMAGE,
  OGP_SITE,
} from '@doda/common/src/constants/properties/arca';
import { appQueryParamsSelector } from '@doda/common/src/redux/features/queryParams';
import { MetaDataSelector } from 'redux/features/jobList';
import { canonicalUrlSelector } from '@doda/common/src/redux/features/canonical';
import { useAppSelector } from 'redux/hooks';
import {
  qualificationSelector,
  searchConditionTextSelector,
} from 'redux/features/careerRecommendJobList';
import { createDescription } from './createDescription';
import { createKeywords } from './createKeywords';
import { createTitle } from './createTitle';

export const MetaTag: React.FC = () => {
  const { page, so } = useAppSelector(appQueryParamsSelector);
  const { name: qualificationName = '' } = useAppSelector(
    qualificationSelector
  );
  const currentPage = page ? Number(page) : 1;
  const jobCount = useAppSelector(MetaDataSelector)?.totalCount ?? 0;
  const canonicalUrl = useAppSelector(canonicalUrlSelector) || '';

  const searchConditionText = useAppSelector(searchConditionTextSelector);
  const optionText = searchConditionText ? `${searchConditionText}の` : '';
  const displayJobCountPerPage = so ? Number(so) : 50;

  const title = createTitle(currentPage, qualificationName, optionText);
  const description = createDescription({
    currentPage,
    displayJobCountPerPage,
    qualificationName,
    optionText,
    jobCount,
  });
  const keywords = createKeywords({
    currentPage,
    displayJobCountPerPage,
    qualificationName,
    optionText,
    jobCount,
  });

  return (
    <Tag
      title={title}
      description={description}
      keywords={keywords}
      type={OGP_TYPE}
      url={canonicalUrl || ''}
      image={OGP_IMAGE}
      siteName={OGP_SITE}
      canonical={jobCount === 0 ? undefined : canonicalUrl}
      robots={jobCount === 0 ? 'noindex' : undefined}
    />
  );
};
